import {
  CLIENT_DOWNLOADS_LIST,
  CLIENT_DOWNLOADS_LIST_SUCCESS,
  CLIENT_DOWNLOADS_LIST_ERROR,
  CLIENT_DOWNLOADS_LIST_EMPTY,
} from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ClientDownloadsList = (state = initialState, action) => {
  switch (action.type) {
    case CLIENT_DOWNLOADS_LIST:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case CLIENT_DOWNLOADS_LIST_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case CLIENT_DOWNLOADS_LIST_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case CLIENT_DOWNLOADS_LIST_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ClientDownloadsList;
